module.exports = __webpack_public_path__ + "h5/img/datou.f45de80f.png";